import client from '../client'
import qs from 'qs'

export const getPointStatistic = async ({ expireDate }) => {
  const queryString = qs.stringify({
    expire_date: expireDate,
  })

  const response = await client.get(`/point/statistic?${queryString}`)

  return response.data
}
